import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import swal from "sweetalert";
import { t } from "i18next";
import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Pagination, TextField, Tooltip, Chip } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";

import React from "react";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
        ref={ref}
        value={value}
        onClick={onClick}
        placeholder="Chọn ngày"
        style={{
            height: "40px",
            padding: "0 10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            outline: "none",
            fontSize: "14px",
            color: "#333",
            backgroundColor: "#fff",
            width: "120px",
            textAlign: "center",
            cursor: "pointer"
        }}
        readOnly
    />
));

function Request() {
    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [note, setNote] = useState("");
    const [setting, setSetting] = useState(null);
    const [profile] = useState(JSON.parse(localStorage.getItem("profile")));
    
    // Quản lý Phân trang và Tìm kiếm
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searched, setSearched] = useState("");
    const [startDate, setStartDate] = useState(() => {
        const d = new Date();
        d.setDate(d.getDate() - 7);
        return d;
    });
    const [endDate, setEndDate] = useState(() => new Date());
    const [status, setStatus] = useState("All");
    const [isGuideOpen, setIsGuideOpen] = useState(false);
    const [maGiaoDich, setMaGiaoDich] = useState("");
    const limit = 10;
    const typingTimeoutRef = useRef(null);

    // States thống kê
    const [totalSuccess, setTotalSuccess] = useState(0);
    const [totalPending, setTotalPending] = useState(0);

    // Timezone-safe local date formatter (YYYY-MM-DD)
    const formatLocalDate = (date) => {
        if (!date) return "";
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - (offset * 60 * 1000));
        return localDate.toISOString().split('T')[0];
    };

    // Hàm lấy dữ liệu
    const fetchWithdrawals = () => {
        setLoading(true);
        const startStr = formatLocalDate(startDate);
        const endStr = formatLocalDate(endDate);
        axios
            .get(`${process.env.REACT_APP_API_URL}/payment/rut?page=${page}&limit=${limit}&search=${searched}&startDate=${startStr}&endDate=${endStr}&status=${status}`)
            .then((res) => {
                setData(res.data.data);
                if (res.data.totalPages) {
                    setTotalPages(res.data.totalPages);
                }
                setTotalSuccess(res.data.totalSuccess || 0);
                setTotalPending(res.data.totalPending || 0);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    const setDatePreset = (preset) => {
        const today = new Date();
        setPage(1);
        switch (preset) {
            case "today": {
                const start = new Date(today);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "yesterday": {
                const start = new Date(today);
                start.setDate(today.getDate() - 1);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "thisWeek": {
                const start = new Date(today);
                const day = today.getDay();
                const diff = today.getDate() - day + (day === 0 ? -6 : 1);
                start.setDate(diff);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "thisMonth": {
                const start = new Date(today.getFullYear(), today.getMonth(), 1);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "lastMonth": {
                const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                const end = new Date(today.getFullYear(), today.getMonth(), 0);
                setStartDate(start);
                setEndDate(end);
                break;
            }
            case "all":
            default: {
                setStartDate(null);
                setEndDate(null);
                break;
            }
        }
    };

    useEffect(() => {
        fetchWithdrawals();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, searched, startDate, endDate, status]);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`)
            .then((res) => {
                if (res.data && res.data.data && res.data.data.length > 0) {
                    setSetting(res.data.data[0]);
                }
            })
            .catch((err) => console.log("Lỗi load setting:", err));
    }, []);

    // Xử lý tìm kiếm có Debounce
    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }
        typingTimeoutRef.current = setTimeout(() => {
            setSearched(value);
            setPage(1); // Chuyển về trang 1
        }, 500);
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            py: 1
                        }}>
                        {loading ? (
                            <div className="loading" style={{ maxWidth: "100%" }}>
                                <div className="loader"></div>
                            </div>
                        ) : null}
                        <Container maxWidth={false}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                                <div>
                                    <h2 style={{ margin: 0, color: "#333", fontSize: "24px" }}>Lịch sử rút tiền</h2>
                                    <p style={{ margin: "5px 0 0 0", color: "#666", fontSize: "14px" }}>Quản lý và theo dõi các giao dịch rút tiền của thành viên</p>
                                </div>
                            </Box>

                            <div className="form_set" style={{ marginTop: 0 }}>
                                <Box>
                                    {/* AX68WIN Filter Block */}
                                    <div className="ax-filter-block">
                                        <div className="ax-filter-grid">
                                            <div className="ax-filter-item" style={{ minWidth: "320px" }}>
                                                <label>📅 Khoảng thời gian</label>
                                                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                                    <div className="ax-date-range">
                                                        <DatePicker
                                                            maxDate={new Date()}
                                                            selected={startDate}
                                                            onChange={(date) => {
                                                                setStartDate(date);
                                                                setPage(1);
                                                            }}
                                                            customInput={<CustomDateInput />}
                                                        />
                                                        <span style={{ color: "#888" }}>→</span>
                                                        <DatePicker
                                                            maxDate={new Date()}
                                                            selected={endDate}
                                                            onChange={(date) => {
                                                                setEndDate(date);
                                                                setPage(1);
                                                            }}
                                                            customInput={<CustomDateInput />}
                                                        />
                                                    </div>
                                                    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                                                        <button type="button" onClick={() => { const now = new Date(); setStartDate(now); setEndDate(now); setPage(1); }} style={{ padding: "4px 8px", fontSize: "11px", borderRadius: "4px", border: "1px solid #1890ff", background: "#e6f7ff", color: "#1890ff", fontWeight: 600, cursor: "pointer" }}>Hôm nay</button>
                                                        <button type="button" onClick={() => { const now = new Date(); const s = new Date(); s.setDate(now.getDate() - 6); setStartDate(s); setEndDate(now); setPage(1); }} style={{ padding: "4px 8px", fontSize: "11px", borderRadius: "4px", border: "1px solid #722ed1", background: "#f9f0ff", color: "#722ed1", fontWeight: 600, cursor: "pointer" }}>7 ngày qua</button>
                                                        <button type="button" onClick={() => { const now = new Date(); setStartDate(new Date(now.getFullYear(), now.getMonth(), 1)); setEndDate(now); setPage(1); }} style={{ padding: "4px 8px", fontSize: "11px", borderRadius: "4px", border: "1px solid #52c41a", background: "#f6ffed", color: "#52c41a", fontWeight: 600, cursor: "pointer" }}>Tháng này</button>
                                                        <button type="button" onClick={() => { const now = new Date(); setStartDate(new Date(now.getFullYear(), now.getMonth() - 1, 1)); setEndDate(new Date(now.getFullYear(), now.getMonth(), 0)); setPage(1); }} style={{ padding: "4px 8px", fontSize: "11px", borderRadius: "4px", border: "1px solid #fa8c16", background: "#fff7e6", color: "#fa8c16", fontWeight: 600, cursor: "pointer" }}>Tháng trước</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="ax-filter-item">
                                                <label>◉ Trạng thái</label>
                                                <select
                                                    value={status}
                                                    onChange={(e) => {
                                                        setStatus(e.target.value);
                                                        setPage(1);
                                                    }}
                                                    style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                                >
                                                    <option value="All">Toàn bộ</option>
                                                    <option value="Pending">Chưa xử lý</option>
                                                    <option value="Processing">Đang xử lý</option>
                                                    <option value="Success">Thành công</option>
                                                    <option value="Deny">Thất bại</option>
                                                </select>
                                            </div>

                                            <div className="ax-filter-item">
                                                <label>👤 Tên người chơi</label>
                                                <input
                                                    type="text"
                                                    placeholder="Tên người chơi"
                                                    onChange={handleSearchChange}
                                                    style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                                />
                                            </div>

                                            <div className="ax-filter-item">
                                                <label># Mã giao dịch</label>
                                                <input
                                                    type="text"
                                                    placeholder="Mã giao dịch"
                                                    value={maGiaoDich}
                                                    onChange={(e) => setMaGiaoDich(e.target.value)}
                                                    style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                                />
                                            </div>

                                            <div className="ax-filter-item" style={{ flexDirection: "row", gap: "8px" }}>
                                                <button className="ax-btn-search-red" onClick={() => { setPage(1); fetchWithdrawals(); }}>
                                                    🔍 Tìm kiếm
                                                </button>
                                                <button className="ax-btn excel" style={{ height: "40px", borderRadius: "8px" }} onClick={() => swal(t("success"), "Đã xuất file excel", "success")}>
                                                    📊 Xuất excel
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Summary Boxes */}
                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "15px", marginBottom: "20px" }}>
                                        <div style={{ background: "linear-gradient(135deg, #1890ff 0%, #0050b3 100%)", borderRadius: "10px", padding: "20px", color: "white", textAlign: "center", boxShadow: "0 4px 10px rgba(24,144,255,0.3)" }}>
                                            <div style={{ fontSize: "14px", marginBottom: "8px", fontWeight: "bold" }}>◉ Tổng giao dịch</div>
                                            <div style={{ fontSize: "24px", fontWeight: "bold" }}>{(totalSuccess + totalPending).toLocaleString("vi-VN")}</div>
                                        </div>
                                        <div style={{ background: "linear-gradient(135deg, #52c41a 0%, #237804 100%)", borderRadius: "10px", padding: "20px", color: "white", textAlign: "center", boxShadow: "0 4px 10px rgba(82,196,26,0.3)" }}>
                                            <div style={{ fontSize: "14px", marginBottom: "8px", fontWeight: "bold" }}>✔ Thành công</div>
                                            <div style={{ fontSize: "24px", fontWeight: "bold" }}>{totalSuccess.toLocaleString("vi-VN")}</div>
                                        </div>
                                        <div style={{ background: "linear-gradient(135deg, #fa8c16 0%, #ad4e00 100%)", borderRadius: "10px", padding: "20px", color: "white", textAlign: "center", boxShadow: "0 4px 10px rgba(250,140,22,0.3)" }}>
                                            <div style={{ fontSize: "14px", marginBottom: "8px", fontWeight: "bold" }}>⏳ Chờ xử lý</div>
                                            <div style={{ fontSize: "24px", fontWeight: "bold" }}>{totalPending.toLocaleString("vi-VN")}</div>
                                        </div>
                                        <div style={{ background: "linear-gradient(135deg, #ff4d4f 0%, #a8071a 100%)", borderRadius: "10px", padding: "20px", color: "white", textAlign: "center", boxShadow: "0 4px 10px rgba(255,77,79,0.3)" }}>
                                            <div style={{ fontSize: "14px", marginBottom: "8px", fontWeight: "bold" }}>✖ Thất bại</div>
                                            <div style={{ fontSize: "24px", fontWeight: "bold" }}>0</div>
                                        </div>
                                    </div>

                                    <div className="ax-table-wrapper">
                                    <Table>
                                        <TableHead sx={{ backgroundColor: "#f0f2f5" }}>
                                            <TableRow>
                                                <TableCell sx={{ padding: "12px 10px", color: "#333 !important", fontWeight: "600 !important", borderBottom: "none" }}>Người chơi</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#333 !important", fontWeight: "600 !important", borderBottom: "none", textAlign: "center" }}>Số tiền</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#333 !important", fontWeight: "600 !important", borderBottom: "none", textAlign: "center" }}>Trạng thái</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#333 !important", fontWeight: "600 !important", borderBottom: "none", textAlign: "center" }}>Ngày tạo</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#333 !important", fontWeight: "600 !important", borderBottom: "none", textAlign: "center" }}>Mã giao dịch</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#333 !important", fontWeight: "600 !important", borderBottom: "none", textAlign: "center" }}>Rủi ro</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {data != null && data.length > 0 ? (
                                            <TableBody>
                                                {/* Hiển thị thẳng dữ liệu */}
                                                {data.map((item) => (
                                                    <TableRow key={item._id} hover>
                                                        <TableCell sx={{ fontWeight: "600", padding: "12px 10px", color: "#555" }}>{item?.user?.username}</TableCell>
                                                        <TableCell sx={{ fontWeight: "600", padding: "12px 10px", textAlign: "center", color: "#ff4d4f" }}>{Number(item?.money).toLocaleString("vi-VN")}</TableCell>
                                                        <TableCell sx={{ padding: "12px 10px", textAlign: "center" }}>
                                                            {item?.status_payment === "Pending" && <span style={{ padding: "4px 12px", borderRadius: "4px", background: "#fa8c16", color: "white", fontSize: "12px", fontWeight: "bold" }}>Chờ xử lý</span>}
                                                            {item?.status_payment === "Processing" && <span style={{ padding: "4px 12px", borderRadius: "4px", background: "#1890ff", color: "white", fontSize: "12px", fontWeight: "bold" }}>Đang xử lý</span>}
                                                            {item?.status_payment === "Success" && <span style={{ padding: "4px 12px", borderRadius: "4px", background: "#52c41a", color: "white", fontSize: "12px", fontWeight: "bold" }}>Thành công</span>}
                                                            {item?.status_payment === "Deny" && <span style={{ padding: "4px 12px", borderRadius: "4px", background: "#ff4d4f", color: "white", fontSize: "12px", fontWeight: "bold" }}>Thất bại</span>}
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "500", padding: "12px 10px", textAlign: "center", color: "#666" }}>{formatDate(new Date(item?.createdAt))}</TableCell>
                                                        <TableCell sx={{ fontWeight: "500", padding: "12px 10px", textAlign: "center", color: "#666" }}>{item?.orderNo || item?._id?.substring(0, 8)}</TableCell>
                                                        
                                                        <TableCell sx={{ padding: "12px 10px", textAlign: "center" }}>
                                                            {item.riskScore !== undefined ? (
                                                                <Box sx={{ display: "flex", flexDirection: "column", gap: "5px", alignItems: "center" }}>
                                                                    {item.riskScore >= 80 ? (
                                                                        <Chip label={`Rủi ro cao`} color="error" size="small" sx={{ fontWeight: "bold" }} />
                                                                    ) : item.riskScore >= 40 ? (
                                                                        <Chip label={`Rủi ro TB`} color="warning" size="small" sx={{ fontWeight: "bold" }} />
                                                                    ) : item.riskScore > 0 ? (
                                                                        <Chip label={`Rủi ro thấp`} size="small" sx={{ fontWeight: "bold", backgroundColor: "#fbc02d", color: "#000" }} />
                                                                    ) : (
                                                                        <Chip label="An toàn" color="success" size="small" sx={{ fontWeight: "bold" }} />
                                                                    )}
                                                                </Box>
                                                            ) : (
                                                                <span style={{ color: "#999" }}>N/A</span>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        ) : (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={8} align="center">{t("empty")}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )}
                                    </Table>
                                    </div>
                                </Box>
                            </div>
                            <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                                {data != null ? <Pagination color="primary" page={page} count={totalPages} size="small" onChange={handleChangePage} /> : null}
                            </Box>
                        </Container>
                    </Box>

                    {/* AX68WIN HƯỚNG DẪN CHI TIẾT MODAL */}
                    {isGuideOpen && (
                        <div className="ax-modal-overlay" onClick={() => setIsGuideOpen(false)}>
                            <div className="ax-modal-card" onClick={(e) => e.stopPropagation()}>
                                <div className="ax-modal-header">
                                    <h3>Hướng dẫn chi tiết</h3>
                                    <span className="close-icon" onClick={() => setIsGuideOpen(false)}>✕</span>
                                </div>
                                <div className="ax-modal-body">
                                    <h4>Khoảng thời gian</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với thời gian đã chọn.</li>
                                    </ul>

                                    <h4>Trạng thái</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với trạng thái đã chọn.</li>
                                        <li>Có 4 sự lựa chọn lần lượt là: Toàn bộ, Chưa xử lý, Thành công, Thất bại. Mặc định là 'Toàn bộ'.</li>
                                    </ul>

                                    <h4>Tên người chơi</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Tên người chơi' đã nhập vào ô văn bản.</li>
                                    </ul>

                                    <h4>Mã giao dịch</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Mã giao dịch' đã nhập vào ô văn bản.</li>
                                    </ul>

                                    <h4>Xuất excel</h4>
                                    <ul>
                                        <li>Được sử dụng để xuất một file excel với tất cả dữ liệu là các thông tin được hiển thị trên bảng kết quả trên màn hình.</li>
                                        <li>Lưu ý: Không thể xuất file của dữ liệu rỗng.</li>
                                    </ul>
                                </div>
                                <div className="ax-modal-footer">
                                    <button className="ax-btn-modal-close" onClick={() => setIsGuideOpen(false)}>
                                        Đóng
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}
export default Request;